import cx from 'classnames'

import { Loader } from '../../../../../common/components'
import {
  SuccessCircle,
  Warning,
} from '../../../../../common/components/ui/Icons'
import { createCsv } from '../../../../commons/utils/csv/createCsv'
import { CampaignSummaryDTO } from '../../models/smsCampaign.model'
import styles from './summary-created-sms-campaign.module.scss'

interface SummaryCreatedSmsCampaignsProps {
  campaignCreated: CampaignSummaryDTO
  isError: string
  isLoading: boolean
}

const SummaryCreatedSmsCampaign = (props: SummaryCreatedSmsCampaignsProps) => {
  const { campaignCreated, isError, isLoading } = props

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.wrapper}>
      {isError ? (
        <>
          <Warning width={80} height={80} className={styles.icon} />
          <div className={cx(styles.titleWrapper, styles.title)}>
            <div>
              The campaign{' '}
              <span className={styles.titleAccent}>{campaignCreated.name}</span>{' '}
              hasn't been created.
            </div>
            <div className={styles.title}>Error: {isError}</div>
          </div>
        </>
      ) : (
        <>
          <SuccessCircle />
          <div className={styles.title}>
            The campaign{' '}
            <span className={styles.titleAccent}>{campaignCreated.name}</span>{' '}
            has been successfully created without errors.
          </div>
        </>
      )}
    </div>
  )
}

export default SummaryCreatedSmsCampaign
